import {Injectable} from '@angular/core';
import {CrudRepository, toMultipleSelectItem } from '@abydos-angular/store';
import {coalesce, RestResponse, LabelValueVO} from '@abydos-angular/core';
import {map, share, tap} from 'rxjs/operators';
import {forkJoin, Observable, of} from 'rxjs';
import {PartnerClientVO,  PartnerClientListVO} from './partner-client.interfaces';
import {PartnerClientRestService} from '../api/partner-client-rest.service';

@Injectable()
export class PartnerClientRepository extends CrudRepository<PartnerClientVO, PartnerClientListVO> {

    constructor(private partnerClientRestService: PartnerClientRestService) {
        super(partnerClientRestService);
    }

    override initSelectItems(): Observable<Map<string, LabelValueVO[]>> {
        return coalesce(this.getCachedSelectItem('initSelectItems'),
            forkJoin([
                of(RestResponse.create({status:'OK', data:[]}))
            ])
        .pipe(
            map(([emptyResponse]) => {
                return {
                    empty: emptyResponse
                };
          })
          , toMultipleSelectItem(['dummy'])
          , share()
          , tap((itemMap) => {
            this.selectItemCache.set('initSelectItems', itemMap);
          }))
      )!;
    }
}
